import { useFeatureFlagEnabled } from '@scouts/helpers'

export const usePostHogFeatureFlags = () => {
    const featureCompanySubscriptionTierUpdates = useFeatureFlagEnabled('feat-company-subscription-tier-updates')
    const featureInvoicePricesIncludeVAT = useFeatureFlagEnabled('feat-invoice-prices-include-vat')

    return {
        featureCompanySubscriptionTierUpdates: !!featureCompanySubscriptionTierUpdates,
        featureInvoicePricesIncludeVAT: !!featureInvoicePricesIncludeVAT,
    }
}
